<tc-fab
        [actions]="actions"
        [canProceedState]="canProceedState"
        [isActive]="isActive"
        [selectedIdx]="selectedSubActionIdx"
        (trigger)="onTrigger($event)"
        (fabClose)="onFabClose()"
        (toggleFAB)="onFABToggle($event)">
</tc-fab>
